import React from 'react';

interface SocialShareButtonsProps {
  lang: string;
  newsId: string;
  newsText: string;
}

const SocialShareButtons: React.FC<SocialShareButtonsProps> = ({ lang, newsId, newsText }) => {
  if (!lang || !newsId) {
    return <div>Error: lang or newsId missing in URL</div>;
  }

  const shareUrl = `https://global24.news/${lang}/trendingnews/${newsId}`;

  // Clean markdown and reduce whitespace
  const cleanedText = newsText
    .replace(/[*_`#~>->]+/g, '')     // Remove markdown symbols like **, __, `, #, etc.
    .replace(/\u3000+/g, ' ')        // Remove full-width spaces (common in Chinese)
    .replace(/\s+/g, ' ')            // Collapse multiple spaces to one
    .trim();

  // Limit tweet text based on language
  const maxLength = lang === 'cn' ? 122 : 230;
  const tweetText = cleanedText.slice(0, maxLength)+"...more at";

  const tweetIntentUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(shareUrl)}`;
  const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;

  return (
    <div className="flex gap-4 mt-2">
      <a
        href={tweetIntentUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
      >
        Tweet
      </a>
      <a
        href={fbUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-700 text-white px-3 py-1 rounded hover:bg-blue-800"
      >
        Facebook
      </a>
    </div>
  );
};

export default SocialShareButtons;
